import React from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';


import PaperCard from './paper-card';

import '../../App.css'

const useStyles = makeStyles(theme => ({
    header: {
      color: 'rgb(182, 193, 220)',
      fontSize: 18, 
      padding: theme.spacing(1, 0, 0, 0),
      fontWeight: 600
    },
    subHeader: {
      color: 'rgb(255, 255, 255)',
      fontWeight: 600,
      padding: theme.spacing(0, 0, 1, 0)
    },
    numberPercent: {
      width: 75,
      padding: theme.spacing(.3),
      borderRadius: 20,
      display: 'flex',
      justifyContent: 'center',
      alignItems:'center',
      fontSize: 20,
      color: 'rgb(255,255,255)',
      borderWidth: 1.5,
      borderColor: 'rgb(3,185,162)'
    },
    height: {
      height: 400
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    percentage: {
      fill: '#fff',
      fontFamily: 'sans-serif',
      fontSize: 2.2,
      textAnchor: 'middle',
      color: '#000',
      fontWeight: 530
    }
    
  }));

export default function AverageCard({className, theme}) {
    const classes = useStyles();
    const { formatMessage } = useIntl();
    const children = (
      <div className={classes.content}>
        <Typography variant="h6" component="p" className={classes.header}>
        {formatMessage({id:"app.subHeader.dashboard.average", defaultMessage: "Average treatement duration"})}
        </Typography>
        <Box>
          <svg viewBox="10.5 -3 15 40" className="circular-chart orange">
            <path
              className="path"
              fill="none"
              stroke={theme ? '#405265': '#e5e5e9'}
              strokeWidth="2.4"
              strokeDasharray="0.5 1.5"
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path 
              className="circle"
              strokeDasharray="10, 100"
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <rect x="12.7" y="20" rx="3"  width="11" height="5" fill="#f00b3f"></rect>
            <text x="18" y="20.35" fill='#fff'>
              <tspan x="10" y="17.5" fontSize="6" fontWeight="bold" fill={theme ? '#fff': '#000'}>6<tspan fontSize="3">min</tspan>52<tspan fontSize="3">s</tspan></tspan>
              <tspan x="18" y="23.3" className={classes.percentage}>+5,6%</tspan>
            </text>
          </svg>
        </Box>
      </div>
    )
    return (
      <PaperCard
        children={children}
        height={classes.height} 
        theme={theme}
      />
    );
}
